import {
  DbotEventDispatcher,
  DecisionContext,
  DecisionTypeHandler,
} from "@/dbot/common/commonDomain";
import { BoardAssignsSignature, BoardAssignsSignatureForm } from "./boardAssignsSignatureDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  _dispatch: DbotEventDispatcher,
  context: DecisionContext<BoardAssignsSignature>,
  data?: BoardAssignsSignature,
): BoardAssignsSignatureForm {
  return new BoardAssignsSignatureForm(context, data);
}

export function isValid(form: BoardAssignsSignatureForm): boolean {
  return form.isValid;
}

export function validate(form: BoardAssignsSignatureForm): boolean {
  return form.validate();
}

export function applyForm(form: BoardAssignsSignatureForm): BoardAssignsSignature {
  return {
    type: DecisionType.boardAssignsSignature,
    signatureAssignedTo: form.signatureAssignedTo.selected,
    signatureAssignedToNamedPersons: form.signatureAssignedToNamedPersons.validatedValue,
    signatureAssignedToNamedBoardMembers: form.signatureAssignedToNamedBoardMembers.selected,
    signatureAssignedToNamedPersonsJointly:
      form.signatureAssignedToNamedPersonsJointly.validatedValue,
    signatureAssignedToNamedBoardMembersJointly:
      form.signatureAssignedToNamedBoardMembersJointly.selected,
    signatureAssignedOtherRegulation: form.signatureAssignedOtherRegulation.validatedValue,
    revokeBoardDecisionsSignatures: form.revokeBoardDecisionsSignatures.value || false,
  };
}

export const boardAssignsSignatureHandler: DecisionTypeHandler<
  DecisionType.boardAssignsSignature,
  BoardAssignsSignature,
  BoardAssignsSignatureForm
> = {
  type: DecisionType.boardAssignsSignature,
  initNewForm,
  isValid,
  validate,
  applyForm,
};
